function NewAdHocSurvey(defaultWeightingMethodCode) {
	return {
		id: null,
		name: "New Question Set",
		startDate: null,
		endDate: null,
		folderId: null,
		questions: [],
		enabled: 0,
		adHocSurveyTypeId: null,
		weightingMethod: defaultWeightingMethodCode,
		deliveryMethod: 0,
		uploadedSchemaFileName: null,
		schemaFile: null,
		quotaDefinitions: [],
		inArchive: 0,
		screenerId: null,
		completeReturnUrl: null,
		screenOutReturnUrl: null,
		quotaFullReturnUrl: null
	}
}
export default NewAdHocSurvey;